import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionReload16 } from '@cian/ui-kit-design-tokens/icons';
import { pluralize } from '@cian/newbuilding-utils';

interface IShowMoreButtonProps {
  onClick: () => void;
  length: number;
}

export function ShowMoreButton({ onClick, length }: IShowMoreButtonProps) {
  return (
    <Button theme="stroke_primary" size="XS" beforeIcon={<IconActionReload16 color="primary_100" />} onClick={onClick}>
      {`Показать еще ${pluralize(length, ['объект', 'объекта', 'объектов'])}`}
    </Button>
  );
}
